import NoDataForSelection from 'components/atoms/NoDataForSelection';
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { FilterContextData } from 'contexts/FilterContext';
import TileButton from 'components/atoms/TileButton';
import DownSvg from 'assets/svg/Down';
import styled from '@emotion/styled';
import { Modal, Select } from 'antd';
import tw from 'twin.macro';
import Button from 'components/atoms/Button';
import SelectionDropDown from 'components/molecules/SelectionDropDown';
import _ from 'lodash';
import AddEditEventModal from 'components/organism/PromoRecommendation/AddEditEventModal';
import { calculateFontSize, sendNotification } from 'utils/helperMethods';
import { CustomSelect } from 'CustomComponentCss';
import SaveScenarioModal from 'components/organism/PromoRecommendation/SaveScenarioModal';
import RecommendationMainSection from 'components/template/PromoRecommendation/RecommendationMainSection';
import useFetchGetPlans, { newPlanObject, newPlanValue } from 'hooks/promoRecommendation/useFetchGetPlans';
import { promoRecommendation } from 'contexts/PromoRecommendationContext';
import { useSaveScenario } from 'hooks/promoRecommendation/useSaveScenario';
import SummarySection from 'components/template/PromoRecommendation/SummarySection';
import PlaybookSection from 'components/template/PromoRecommendation/PlaybookSection';
import { UserContext } from 'contexts/ConfigContext';
import { trackEventMixpanel } from 'utils/mixpanel';
import ImportEventModel from 'components/organism/PromoRecommendation/ImportEventModel';
import OptimizeScenarioModel from 'components/organism/PromoRecommendation/OptimizeScenarioModel';

import {
    PROMO_RECOMMENDATION_ADD_EVENT_CLICKED,
    PROMO_RECOMMENDATION_CALENDER_KPI_TAB_CHANGED,
    PROMO_RECOMMENDATION_MAIN_TAB_CHANGED,
    PROMO_RECOMMENDATION_NEW_SCENARIO_SELECTED,
    PROMO_RECOMMENDATION_SAVE_SCENARIO_CLICKED,
    PROMO_RECOMMENDATION_SELECT_SCENARIO_DROPDOWN_CHANGED,
} from 'utils/mixpanelEventNames';
import EditPencilOutlined from 'assets/svg/EditPencilOutlined';
import { useFetchAllScenarios } from 'hooks/priceSimulator';
import LinkScenarioModal from 'components/organism/PromoRecommendation/LinkScenarioModal';
import DownloadExcel from 'components/molecules/MicroIntractions/DownloadExcel';
import PromoRecommendationContainer from './PromoRecommendationContainer';
import { promoRecommendationPlansTableColumns } from 'utils/getRecommendationTableColumns';
import Breadcrumb from 'components/atoms/Breadcrumb';
import { CheckCircleFilled } from '@ant-design/icons';
import { colorConstants } from 'config/colorConstants';
import PromoRecommendationLibrarySection from 'components/template/PromoRecommendation/PromoRecommendationLibrarySection';
import { queryClient } from 'services/reactQueryService';
import { PromoLibraryKpiConfigType } from 'types/tradePromoOptimization';

export const commonClassName = 'border  border-borderLinePurpuleAlt p-4 rounded-lg';
export const commonHeaderClass = 'font-medium font-xl m-0 text-headerColor';

const scaledWidth = calculateFontSize(window.innerWidth, 13);
const ScaleInput = calculateFontSize(window.innerWidth, 200);

const typeSelection = [
    { key: 'Calender', label: 'Calender' },
    { key: 'KPI', label: 'KPI' },
];

export const CustomModalForSave = styled(Modal)`
    .ant-modal-close-x span svg {
        fill: black;
    }
    .ant-modal-title {
        font-size: '${scaledWidth}px';
        font-weight: 500;
    }
    .custom-modal .ant-modal-content {
        border-radius: 30px !important;
    }
`;

function PromoRecommendation() {
    const { filterNullError, allCheckedAttribute, idForRestOfComponent, allDimAndAttributeTypeList } =
        useContext(FilterContextData);
    const { appConfig: config } = useContext(UserContext);
    const { promoRecommendation: promoRecommendationConfig } = config;
    const menuButtons = promoRecommendationConfig.menuButtons;
    const retailerKey = promoRecommendationConfig.retailerKey;
    const kpiTableDataKeyMapping = promoRecommendationConfig.overlayKeys?.slice(4);
    const [activeMenuKey, setActiveMenuKey] = useState(menuButtons[0]);
    const [activeType, setActiveType] = useState(typeSelection[0]);
    const [saveScenarioModal, setSaveScenarioModal] = useState(false);
    const [openEditScenarioModal, setOpenEditScenarioModal] = useState(false);
    const addEventData = config.promoRecommendation.addEventList;
    const hideShowOptimizeButton = config.promoRecommendation.hideShowOptimizeButton;
    const [eventList, setEventList] = useState(addEventData[0]);
    const [importDialogBox, setImportDialogBox] = useState(false);
    const [openOptimizeDialogBox, setOpenOptimizeDialogBox] = useState(false);
    const [selectedSimulationKey, setSelectedSimulationKeys] = useState<any[]>([]);

    const userEmail = localStorage.getItem('email');
    const editAccessRoll = {
        'vijay.shankar@asper.ai': ['%TS', 'ROI'],
        'komal.singh@asper.ai': ['Frequency'],
        'sunil.ranganathan@asper.ai': ['%TS', 'Frequency', 'ROI'],
    };

    let playbookKpiValues: any;
    const playbookKpiValuesString = localStorage.getItem('playbookKpiValues');
    if (playbookKpiValuesString !== null) {
        playbookKpiValues = JSON.parse(playbookKpiValuesString);
    }

    const [isToggled, setIsToggled] = useState(true);
    const [roi, setRoi] = useState(playbookKpiValues?.GuidelinesROI || 20);
    const [ts, setTs] = useState(playbookKpiValues?.GuidelinesTS || 33);
    const [frequency1, sefrequency1] = useState(playbookKpiValues?.GuidelinesFrequency1 || 4);
    const [frequency2, sefrequency2] = useState(playbookKpiValues?.GuidelinesFrequency2 || 6);
    const [promoLibraryKpiConfigData, setPromoLibraryKpiConfigData] = useState<null | PromoLibraryKpiConfigType>(null);

    const {
        selectedPlan,
        setSelectPlan,
        setLoadingForPlanList,
        setSelectedKpiList: setSelectedKPI,
        selectedKpiList: selectedKPI,
        addEditModal,
        fetchEventsList,
        setAddEditModal,
        PromotionMechanicValueData,
        eventsListData,
    } = useContext(promoRecommendation);

    const updateTypeRef: any = useRef();

    const {
        loading: allScenariosLoading,
        data: allScenariosData,
        error: allScenariosError,
        fetchAllScenarios,
    } = useFetchAllScenarios();

    useEffect(() => {
        fetchAllScenarios({
            variables: {
                limit: 10000, // since we need all the scenario , setting limit as high number
                offset: 0,
            },
        });
    }, []);

    //kpi list shown in kpi table dropdown
    const kpiList = useMemo(() => {
        return kpiTableDataKeyMapping?.map((item: any) => {
            return {
                label: item?.label,
                value: item?.label,
            };
        });
    }, []);
    const {
        data: planData,
        loading: planLoading,
        error: planError,
        fetchPlan,
        tableData: planTableData,
    } = useFetchGetPlans();
    const {
        saveScenario,
        loading: saveScenarioLoading,
        error: saveScenarioError,
        setError: setSaveScenarioError,
    } = useSaveScenario({ onComplete: onSaveScenarioComplete });

    const modifiedPlanData = planData.slice(1);

    // useEffect(() => {
    //     if (planData.length) {
    //         setSelectPlan(planData[1]);
    //     }
    // }, [planData]);
    //only call api once during the load of screen and if retailer present
    useEffect(() => {
        if (allCheckedAttribute && Object.keys(allCheckedAttribute?.[retailerKey] || {})?.length)
            fetchPlan({
                variables: {
                    dim2AttributeName: `${Object.keys(allCheckedAttribute[retailerKey])[0]}`,
                },
            });
        setSelectPlan(undefined);
        //if no retailer present, show error message
        if (
            allCheckedAttribute &&
            retailerKey in allCheckedAttribute &&
            Object.keys(allCheckedAttribute?.[retailerKey] || {})?.length === 0
        ) {
            sendNotification('error', `Please select 1 ${retailerKey} from global filter`);
        }
    }, [idForRestOfComponent]);

    const combinedLoading = allDimAndAttributeTypeList?.loading || planLoading;

    useEffect(() => {
        setLoadingForPlanList(combinedLoading);
    }, [combinedLoading]);

    //called when saved scenario is completed
    function onSaveScenarioComplete() {
        setSaveScenarioModal(false);
        setOpenEditScenarioModal(false);

        //if coming from add then fetch plan
        if (updateTypeRef.current === 'add') {
            //refetch the plan list to get updated plans
            fetchPlan({
                variables: {
                    dim2AttributeName: `${Object.keys(allCheckedAttribute[retailerKey])[0]}`,
                },
            });
        } else {
            //refetch the events list
            fetchEventsList({
                variables: {
                    planId: selectedPlan?.planId,
                },
            });
        }
    }

    function onOptimizeComplete() {
        fetchEventsList({
            variables: {
                planId: selectedPlan?.planId,
            },
        });
    }

    //called when clicked on save button
    const onAddScenario = useCallback(
        (payload: any = {}) => {
            const tempObj = {
                plan_name: payload?.text,
                dim2_attribute_name: `${Object.keys(allCheckedAttribute[retailerKey])[0]}`,
                saved_type: 'final',
            };
            updateTypeRef.current = 'add';

            saveScenario({
                variables: {
                    operationType: 'add',
                    planId: selectedPlan?.planId,
                    metaData: JSON.stringify(tempObj),
                    scenarioId: selectedPriceScenario?.scenarioId,
                    createdBy: userEmail,
                },
            });
        },
        [selectedPlan, selectedSimulationKey],
    );

    // update the linking for existing ones
    useEffect(() => {
        if (selectedPlan?.scenarioId) {
            setSelectedSimulationKeys([selectedPlan.scenarioId]);
        }
    }, [selectedPlan]);

    //called when clicked on save button
    const onEditScenario = useCallback(
        (payload: any = {}) => {
            const tempObj = {
                plan_name: selectedPlan?.label,
                dim2_attribute_name: `${Object.keys(allCheckedAttribute['Retailer'])[0]}`,
                saved_type: 'final',
            };
            updateTypeRef.current = 'save';

            saveScenario({
                variables: {
                    operationType: 'save',
                    planId: selectedPlan?.planId,
                    metaData: JSON.stringify(tempObj),
                    scenarioId: selectedPriceScenario?.scenarioId,
                },
            });
        },
        [selectedPlan, selectedSimulationKey],
    );

    //called when clicked on save button
    const onSaveScenario = useCallback(() => {
        updateTypeRef.current = 'save';
        saveScenario({
            variables: {
                metaData: '{}',
                operationType: 'save',
                planId: selectedPlan?.planId,
            },
        });
    }, [selectedPlan]);

    const selectedPriceScenario = useMemo(() => {
        if (selectedSimulationKey.length > 0)
            return allScenariosData?.find((s: any) => s.key === selectedSimulationKey[0]);
        return null;
    }, [selectedSimulationKey]);

    useEffect(() => {
        queryClient.removeQueries({
            queryKey: ['promo-recommendation-promo-library-data'],
            exact: false,
        });
    }, [selectedPlan]);
    return (
        <section>
            {selectedPlan?.planId ? (
                <Breadcrumb
                    items={[
                        {
                            label: 'Trade Promo Optimization',
                            onClick: () => {
                                setSelectPlan(null);
                                setActiveMenuKey(menuButtons[0]);
                            },
                            className: 'cursor-pointer',
                        },
                        { label: selectedPlan?.label },
                    ]}
                />
            ) : null}

            <div className={` ${commonClassName} bg-white`}>
                {filterNullError ? (
                    <NoDataForSelection />
                ) : (
                    <div>
                        {!selectedPlan?.planId ? (
                            <>
                                <div className="mb-2 flex justify-between items-center">
                                    <h2 className={commonHeaderClass}>{'Trade Promo Optimization'}</h2>
                                    <Button
                                        disabled={combinedLoading}
                                        title={'Create New Plan'}
                                        onClick={() => {
                                            setSelectPlan({ ...newPlanObject });
                                            setSaveScenarioModal(() => true);
                                            trackEventMixpanel(PROMO_RECOMMENDATION_NEW_SCENARIO_SELECTED);
                                        }}
                                    />
                                </div>
                                <PromoRecommendationContainer
                                    setSelectedPlan={setSelectPlan}
                                    planData={planTableData}
                                    planLoading={combinedLoading}
                                    planError={planError}
                                />
                            </>
                        ) : (
                            <>
                                <div className="flex justify-start gap-4 items-center">
                                    <h2 className={commonHeaderClass}>{'Trade Promo Optimization'}</h2>
                                    <TileButton
                                        disabled={combinedLoading}
                                        data={menuButtons}
                                        activeKey={activeMenuKey?.key}
                                        onClick={(item: any) => {
                                            setPromoLibraryKpiConfigData(null);
                                            setActiveMenuKey(item);
                                            trackEventMixpanel(PROMO_RECOMMENDATION_MAIN_TAB_CHANGED, {
                                                tabName: item?.label,
                                            });
                                        }}
                                    />
                                </div>
                                {activeMenuKey.key === menuButtons[0]?.key ? (
                                    <>
                                        <div className="mt-2 flex justify-between">
                                            <div className="flex gap-3">
                                                {/* <CustomSelect
                                                suffixIcon={<DownSvg />}
                                                //loading={allDimAndAttributeTypeList?.loading}
                                                value={selectedPlan}
                                                options={planData}
                                                className="dropdown-height dropdown-width-alt uniqSelPRScenerioDropdown"
                                                onChange={(val: any, item: any) => {
                                                    setSelectPlan(item);
                                                    trackEventMixpanel(
                                                        PROMO_RECOMMENDATION_SELECT_SCENARIO_DROPDOWN_CHANGED,
                                                        {
                                                            dropdownName: item?.label,
                                                        },
                                                    );
                                                }}
                                                onSelect={(value) => {
                                                    if (value == 'newPlanPR') {
                                                        setSaveScenarioModal(() => true);
                                                        trackEventMixpanel(PROMO_RECOMMENDATION_NEW_SCENARIO_SELECTED);
                                                    }
                                                }}
                                                loading={combinedLoading}
                                                disabled={combinedLoading}
                                            /> */}
                                                {selectedPlan?.optimizationStatus === 'completed' && (
                                                    <div>
                                                        <CheckCircleFilled
                                                            style={{
                                                                fontSize: 16,
                                                                color: colorConstants.limeGreen,
                                                            }}
                                                        />
                                                    </div>
                                                )}

                                                <Button
                                                    disabled={selectedPlan?.value === newPlanValue || !selectedPlan}
                                                    title={'Save Scenario'}
                                                    onClick={() => {
                                                        trackEventMixpanel(PROMO_RECOMMENDATION_SAVE_SCENARIO_CLICKED);
                                                        onSaveScenario();
                                                    }}
                                                />
                                                {planData.length > 1 ? (
                                                    <CustomSelect
                                                        suffixIcon={<DownSvg />}
                                                        value={eventList}
                                                        options={addEventData}
                                                        className="dropdown-height dropdown-width-alt uniqSelPRScenerioDropdown"
                                                        onChange={(val: any, item: any) => {
                                                            setEventList(item);
                                                        }}
                                                        onSelect={(value) => {
                                                            if (value === 'new') {
                                                                setAddEditModal(true);
                                                                trackEventMixpanel(
                                                                    PROMO_RECOMMENDATION_ADD_EVENT_CLICKED,
                                                                );
                                                            } else {
                                                                setImportDialogBox(true);
                                                            }
                                                        }}
                                                    />
                                                ) : (
                                                    ''
                                                )}
                                                {hideShowOptimizeButton ? (
                                                    <Button
                                                        disabled={selectedPlan?.value === newPlanValue || !selectedPlan}
                                                        title={'Optimize Scenario'}
                                                        onClick={() => {
                                                            setOpenOptimizeDialogBox(true);
                                                        }}
                                                        theme={'Solid'}
                                                    />
                                                ) : null}

                                                {selectedPlan?.planId > 0 && selectedPriceScenario && (
                                                    <div className="flex items-center">
                                                        <div className="bg-bgBackground px-4 py-0.5 font-xs  text-purpleFont rounded flex gap-1 justify-center items-center">
                                                            Pricing Scenario Linked:
                                                            <span className="text-greyFont">
                                                                {selectedPriceScenario.Scenario}
                                                            </span>
                                                            <span
                                                                className="cursor-pointer ml-2"
                                                                onClick={() => {
                                                                    setOpenEditScenarioModal(true);
                                                                }}
                                                            >
                                                                <EditPencilOutlined customIndex={1} />
                                                            </span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="flex gap-3">
                                                {activeType.key == 'KPI' && (
                                                    <SelectionDropDown
                                                        list={kpiList}
                                                        className="dropdown-width-alt"
                                                        checkedListObject={selectedKPI}
                                                        disabled={false}
                                                        setSelectedList={setSelectedKPI}
                                                        selectedList={selectedKPI}
                                                    />
                                                )}
                                                <div className="flex items-center gap-2">
                                                    <TileButton
                                                        data={typeSelection}
                                                        activeKey={activeType.key}
                                                        onClick={(item: any) => {
                                                            setActiveType(item);
                                                            trackEventMixpanel(
                                                                PROMO_RECOMMENDATION_CALENDER_KPI_TAB_CHANGED,
                                                                {
                                                                    tabName: item?.label,
                                                                },
                                                            );
                                                        }}
                                                    />
                                                    {eventsListData?.exportData && (
                                                        <DownloadExcel
                                                            title={'promo recommendation Data'}
                                                            excelData={eventsListData?.exportData?.data ?? []}
                                                            headers={eventsListData?.exportData?.header ?? []}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <RecommendationMainSection activeType={activeType} />
                                    </>
                                ) : activeMenuKey.key === menuButtons[1]?.key ? (
                                    <>
                                        <div className="mt-4">
                                            <SummarySection planData={planData} />
                                        </div>
                                    </>
                                ) : activeMenuKey.key === menuButtons[2]?.key ? (
                                    <div className="mt-4">
                                        <PlaybookSection
                                            isToggled={isToggled}
                                            setIsToggled={setIsToggled}
                                            roi={roi}
                                            setRoi={setRoi}
                                            ts={ts}
                                            setTs={setTs}
                                            frequency1={frequency1}
                                            sefrequency1={sefrequency1}
                                            frequency2={frequency2}
                                            sefrequency2={sefrequency2}
                                            userEmail={userEmail}
                                            editAccessRoll={editAccessRoll}
                                        />
                                    </div>
                                ) : activeMenuKey.key === menuButtons[3]?.key ? (
                                    <PromoRecommendationLibrarySection
                                        setPromoLibraryKpiConfigData={setPromoLibraryKpiConfigData}
                                        promoLibraryKpiConfigData={promoLibraryKpiConfigData}
                                        from="promo_library"
                                    />
                                ) : activeMenuKey.key === menuButtons[4]?.key ? (
                                    <PromoRecommendationLibrarySection
                                        setPromoLibraryKpiConfigData={setPromoLibraryKpiConfigData}
                                        promoLibraryKpiConfigData={promoLibraryKpiConfigData}
                                        from="product_constraint"
                                    />
                                ) : null}
                            </>
                        )}
                    </div>
                )}

                {activeMenuKey.key === menuButtons[0]?.key && (
                    <>
                        <AddEditEventModal
                            setAddEditModal={setAddEditModal}
                            addEditModal={addEditModal}
                            PromotionMechanicValueData={PromotionMechanicValueData}
                        />
                        {/* pop up */}
                        <SaveScenarioModal
                            error={saveScenarioError ? String(saveScenarioError) : undefined}
                            loading={saveScenarioLoading}
                            onSave={onAddScenario}
                            setSaveScenario={setSaveScenarioModal}
                            saveScenario={saveScenarioModal}
                            title={'New Plan'}
                            setError={setSaveScenarioError}
                            selectedSimulationKey={selectedSimulationKey}
                            setSelectedSimulationKeys={setSelectedSimulationKeys}
                            allScenariosData={allScenariosData}
                        />
                    </>
                )}
                <ImportEventModel
                    selectedPlan={selectedPlan?.planId}
                    modifiedPlanData={modifiedPlanData}
                    importDialogBox={importDialogBox}
                    setImportDialogBox={setImportDialogBox}
                />
                <OptimizeScenarioModel
                    openOptimizeDialogBox={openOptimizeDialogBox}
                    setOpenOptimizeDialogBox={setOpenOptimizeDialogBox}
                    selectedPlan={selectedPlan}
                    onOptimizeComplete={onOptimizeComplete}
                />
                <LinkScenarioModal
                    onSave={onEditScenario}
                    loading={saveScenarioLoading}
                    setSaveScenario={setOpenEditScenarioModal}
                    saveScenario={openEditScenarioModal}
                    title={'Change linked pricing scenario'}
                    selectedSimulationKey={selectedSimulationKey}
                    setSelectedSimulationKeys={setSelectedSimulationKeys}
                    allScenariosData={allScenariosData}
                />
            </div>
        </section>
    );
}

export default PromoRecommendation;
